import { Link } from "react-router-dom";

const columns = [
  {
    title: "影视浏览",
    links: [
      { label: "全部影视", to: "/category" },
      { label: "电影专区", to: "/category?type=movie" },
      { label: "电视剧专区", to: "/category?type=tv" },
      { label: "站内搜索", to: "/search" },
    ],
  },
  {
    title: "内容栏目",
    links: [
      { label: "影视资讯", to: "/news" },
      { label: "剧情解读", to: "/news" },
      { label: "幕后特辑", to: "/news" },
      { label: "修复重映", to: "/news" },
    ],
  },
  {
    title: "关于站点",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "品牌理念", to: "/about" },
      { label: "联系方式", to: "/about" },
      { label: "版权说明", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-auto w-full border-t border-background-200/80 bg-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-6">
          <div className="md:col-span-4">
            <Link to="/" className="flex cursor-pointer items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg leading-none" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">女友的妈妈</span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一个专注影视剧情与行业资讯的展示型内容门户，收录电影、电视剧的剧情介绍、幕后故事与专题解读，帮助影视爱好者更完整地理解一部作品。
            </p>
            <p className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-information-line text-xs leading-none" />
              </span>
              本站内容为演示数据，仅供信息查阅
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="font-heading text-sm font-semibold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={`${col.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-foreground-950">站内入口</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/category?type=movie" className="cursor-pointer text-sm text-foreground-600 hover:text-primary-700">
                  电影分类
                </Link>
              </li>
              <li>
                <Link to="/category?type=tv" className="cursor-pointer text-sm text-foreground-600 hover:text-primary-700">
                  电视剧分类
                </Link>
              </li>
              <li>
                <Link to="/news" className="cursor-pointer text-sm text-foreground-600 hover:text-primary-700">
                  最新资讯
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer text-sm text-foreground-600 hover:text-primary-700">
                  留言与联系
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 女友的妈妈影视专区 · 本站为影视资讯展示平台，不提供播放与下载服务</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>演示数据均为虚构示例</span>
            <span className="hidden sm:inline text-background-400">|</span>
            <span>影视资料仅供参考</span>
          </p>
        </div>
      </div>
    </footer>
  );
}